import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistSubmissionApi } from 'src/Services/API';

const useFetchChecklistSubmissions = (submissionId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-checklist-submission', submissionId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!submissionId) throw new Error('No checklistId provided');

      return (
        await checklistSubmissionApi.checklistSubmissionsControllerFindOne(submissionId, assetId)
      ).data;
    },
    enabled: !!assetId && !!submissionId,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });
};

export default useFetchChecklistSubmissions;
